exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#content[data-v-2241c1f4]{padding-top:0}", ""]);

// exports
